import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { FacebookService, InitParams } from 'ngx-facebook';
import { facebook } from 'src/environments/environment';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { s3Asset } from 'src/environments/environment';
import { map, Observable } from 'rxjs';
import { CurrentUserSelector, IsAuthenticated } from '@biz-selectors/app.selectors';
import { Store } from '@ngrx/store';

interface Language {
	value: string;
	viewValue: string;
}

@Component({
	selector: 'app-root',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.scss'],
})
export class AppComponent {
	title = 'bzai-passport';
	lang: string;
	selectedValue = 'en';
	background = '';
	// path: string;

	langs: Language[] = [
		{ value: 'en', viewValue: 'English' },
		{ value: 'cn', viewValue: '中文' },
	];
	isLogin$: Observable<boolean>;
	userName$: Observable<string>;

	constructor(
		private translate: TranslateService,
		private route: ActivatedRoute,
		private router: Router,
		private fb: FacebookService,
		private matIconRegistry: MatIconRegistry,
		private domSanitizer: DomSanitizer,
		private store: Store,
	) {
		translate.setDefaultLang('en');
		this.matIconRegistry.addSvgIconSet(
			this.domSanitizer.bypassSecurityTrustResourceUrl(`${s3Asset}/icons/iconset.svg`),
		);
	}

	ngOnInit() {
		this.initFb();

		this.route.queryParamMap.subscribe((params) => {
			if (params.get('lang') == 'en') {
				this.translate.use('en');
				this.selectedValue = 'en';
			}
			if (params.get('lang') == 'cn') {
				this.translate.use('cn');
				this.selectedValue = 'cn';
			}
			if (!params.get('lang')) {
				this.translate.use('en');
			}
		});
		this.route.queryParamMap.subscribe((params) => {
			if (params.get('utm_source') == 'easystore') {
				this.background = 'easystore-';
			} else {
				this.background = '';
			}
		});
		// this.router.events.subscribe(data =>{
		// 	var x = window.location.pathname.substring(1);
		// 	if(x != ''){
		// 		this.path = window.location.pathname.replace("/","-");
		// 		console.log(this.path);
		// 	}else{
		// 		this.path = "-login";
		// 	}
		// });
		this.isLogin$ = this.store.select(IsAuthenticated);
		this.userName$ = this.store.select(CurrentUserSelector).pipe(map((u) => u.name));
	}
	useLanguage() {
		if (this.selectedValue === 'cn') {
			this.lang = 'cn';
			// this.selectedValue = "Chinese";
		} else {
			this.lang = 'en';
			// this.selectedValue = "English";
		}
		this.translate.use(this.lang);
	}

	private initFb(): void {
		// const initParams: InitParams = { xfbml:true, version:facebook.version };
		// this.fb.init(initParams);
	}
}
